import React from "react"
import styled, { keyframes } from "styled-components"

export default function EndingFooter({ footerState }: any) {
  return (
    <EFDiv isLose={footerState === "ending"}>
      <RedDot></RedDot>
      <p>ASTEROID IMPACT ALERT!</p>
    </EFDiv>
  )
}

const EFDiv = styled.div<{ isLose: boolean }>`
  display: ${({ isLose }) => (isLose ? "flex" : "none")};
  /* display:  'flex'; */
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0px;

  width: 336px;
  height: 124px;
  bottom: 0;

  background: rgba(48, 30, 86, 0.85);
  border-radius: 20px;
`

export const RedDot = styled.div`
  position: static;
  width: 32px;
  height: 32px;
  left: 152px;
  top: 28.5px;

  background: #ff0000;
  border: 3px solid #171731;
  border-radius: 100%;
  box-sizing: border-box;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0 0 15px 0;
  animation-name: ${(fade) => fade && fadeOut};
  animation-duration: 0.5s;
  animation-iteration-count: infinite;
`

const fadeOut = keyframes`
 0% {   opacity: 1; }
  50% {  opacity: 0; }
  100% {  opacity: 1; }
`
